import axios from 'axios';
import moment from 'moment';

class MitSpacesService {
  constructor() {
    this.spaceBuildingId = 1;//default, not ideal, but for now...
    this.SPACE_TYPES = {
      building:{
            name: 'Building',
            id: 'building'
      },
      floor:{
            name: 'Floor',
            id: 'floor'
      },
      room:{
            name: 'Room',
            id: 'room'
      },
      area: {
            name: 'Area',
            id: 'area'
      }
    };
    this.SPACE_TYPES_DEFAULT = this.SPACE_TYPES.room;
    this.SPACE_TYPES_ARRAY = [];//array version, helper for things like selection boxes that need an array.

    for(let k in this.SPACE_TYPES){
      this.SPACE_TYPES_ARRAY.push(this.SPACE_TYPES[k]);
    }
  }

  adaptTreeToUIModel(tree){
    tree = this.adaptToUIModel(tree);

    if(tree.children && tree.children.length > 0){
      for(let x = 0; x < tree.children.length; x++){
        this.adaptTreeToUIModel(tree.children[x]);
      }
    }
  }
  adaptTreeToAPIModel(tree){
    tree = this.adaptToAPIModel(tree);

    if(tree.children && tree.children.length > 0){
      for(let x = 0; x < tree.children.length; x++){
        this.adaptTreeToAPIModel(tree.children[x]);
      }
    }
  }
  adaptToUIModel(space){
    //space.type = this.SPACE_TYPES[space.type];//replace with UI type.
    space.ui = {
      lastEditedDt: space.lastEditDt ? moment(space.lastEditedDt).local().fromNow() : null
    };
    switch(space.spaceType){
        case 'campus':
            space.ui.icon = 'mdi-domain';
            break;
        case 'building':
            space.ui.icon = 'mdi-office-building-outline';
            break;
        case 'floor':
            space.ui.icon = 'mdi-floor-plan';
            break;
        case 'space':
            space.ui.icon = 'mdi-door-open';
            break;
    }
    return space;
  }
  adaptToAPIModel(space){
    space.type = space.type.id;
    delete space.dates_local;

    return space;
  }

  getBuildings() {
    return new Promise ((resolve, reject) => {

      axios.get('/api/v1/user/spaces/buildings')
        .then((response) => {
            return resolve(response.data.buildings);
        })
        .catch((error) => {
          console.log('ERROR:', error);
          return reject(error.response.data);
        });

    });
  }
  getBuildingFloors() {
    return new Promise ((resolve, reject) => {
     axios.get('/api/v1/user/spaces/buildings/'+this.spaceBuildingId+'?spaceTypes=floor,building')
        .then((response) => {
            return resolve(response.data.buildings);
        })
        .catch((error) => {
          console.log('ERROR:', error);
          return reject(error.response.data);
        });

    });
  }
  getSpaces(options) {
    return new Promise ((resolve, reject) => {

        let url = new URL(window.location.origin+'/api/v2/user/spaces');

        for (let prop in options) {
          if (options.hasOwnProperty(prop)) {
            url.searchParams.append(prop, options[prop]);
          }
        }

      axios.get(url.pathname+url.search)
        .then((response) => {
            for(let x = 0; x < response.data.spaces.length; x++){
              response.data.spaces[x] = this.adaptToUIModel(response.data.spaces[x]);
            }
            return resolve(response.data.spaces);
        })
        .catch((error) => {
          console.log('ERROR:', error);
          return reject(error);
        });

    });
  }
  getSpacesList(buildingId) {
    return new Promise ((resolve, reject) => {

      axios.get('/api/v2/user/spaces/?buildingId='+buildingId)
        .then((response) => {
            let data = response.data;

            data.spacesNameDictionary = {};//Add a dictionary for fast lookup by name

            for(let x = 0; x < data.spaces.length; x++){
              data.spaces[x] = this.adaptToUIModel(data.spaces[x]);
              data.spacesNameDictionary[data.spaces[x].name] = data.spaces[x];
            }
            return resolve(data);
        })
        .catch((error) => {
          console.log('ERROR:', error);
          return reject(error.response.data);
        });

    });
  }
  getAllSpacesList() {
    return new Promise ((resolve, reject) => {

      axios.get('/api/v2/user/spaces/?types=space')
        .then((response) => {
            let data = response.data;

            data.spacesNameDictionary = {};//Add a dictionary for fast lookup by name

            for(let x = 0; x < data.spaces.length; x++){
              data.spaces[x] = this.adaptToUIModel(data.spaces[x]);
              data.spacesNameDictionary[data.spaces[x].name] = data.spaces[x];
            }
            return resolve(data);
        })
        .catch((error) => {
          console.log('ERROR:', error);
          return reject(error.response.data);
        });

    });
  }

  // getBuildingSpacesList(filterBySpaceType) {
  //   return new Promise ((resolve, reject) => {
  //     let url = '/api/v1/user/spaces/buildings/'+this.spaceBuildingId;
  //
  //     if(filterBySpaceType) url += '?spaceTypes='+filterBySpaceType;
  //
  //     axios.get(url)
  //       .then((response) => {
  //           let data = response.data;
  //
  //           data.spacesNameDictionary = {};//Add a dictionary for fast lookup by name
  //
  //           for(let x = 0; x < data.spaces.length; x++){
  //             data.spaces[x] = this.adaptToUIModel(data.spaces[x]);
  //             data.spacesNameDictionary[data.spaces[x].name] = data.spaces[x];
  //           }
  //           return resolve(data);
  //       })
  //       .catch((error) => {
  //         console.log('ERROR:', error);
  //         return reject(error.response.data);
  //       });
  //
  //   });
  // }
  getBuildingSpacesTree() {
    return new Promise ((resolve, reject) => {

      axios.get('/api/v2/user/spaces/tree')
        .then((response) => {
            //Create a dummy node to satisfy trees so we can have a top level campus
            let campus = this.campus = {
                mitId:'campus',
                displayName:'Campus',
                spaceType:'campus',
                children:response.data.campus
            };
            this.adaptTreeToUIModel(campus);
            return resolve(campus);
        })
        .catch((error) => {
          console.log('ERROR:', error);
          return reject(error);
        });

    });
  }

  getBuildingCoordinates(buildingId, options) {
    return new Promise ((resolve, reject) => {
        let url = new URL(window.location.origin+'/api/v2/user/spaces/buildings/'+buildingId+'/coordinates');

        for (let prop in options) {
          if (options.hasOwnProperty(prop)) {
            url.searchParams.append(prop, options[prop]);
          }
        }

      axios.get(url.pathname+url.search)
        .then((response) => {
            return resolve(response.data.coordinates);
        })
        .catch((error) => {
          console.log('ERROR:', error);
          return reject(error.response.data);
        });

    });
  }

  getBuildingGeoJson(buildingId,options) {
    return new Promise ((resolve, reject) => {
        let url = new URL(window.location.origin+'/api/v2/user/spaces/buildings/'+buildingId+'/geojson');

        for (let prop in options) {
          if (options.hasOwnProperty(prop)) {
            url.searchParams.append(prop, options[prop]);
          }
        }

      axios.get(url.pathname+url.search)
        .then((response) => {
            return resolve(response.data.geojson);
        })
        .catch((error) => {
          console.log('ERROR:', error);
          return reject(error.response.data);
        });

    });
  }
  getAllBuildingStats() {
    return new Promise ((resolve, reject) => {
        axios.get('/api/v2/user/spaces/all/buildings/stats')
            .then((response) => {
                return resolve(response.data);
            })
            .catch((error) => {
              console.log('ERROR:', error);
              return reject(error.response.data);
            });

    });
  }
  getBuildingStats(buildingId,version) {
    return new Promise ((resolve, reject) => {
        let url = '/api/v2/user/spaces/buildings/'+buildingId+'/stats';

        if(version){
            url += '?version='+version;
        }
        axios.get(url)
            .then((response) => {
                return resolve(response.data);
            })
            .catch((error) => {
              console.log('ERROR:', error);
              return reject(error.response.data);
            });

    });
  }
  getBuildings() {
    return new Promise ((resolve, reject) => {

      axios.get('/api/v2/user/spaces/buildings')
        .then((response) => {
            return resolve(response.data.buildings);
        })
        .catch((error) => {
          console.log('ERROR:', error);
          return reject(error.response.data);
        });

    });
  }
  getBuildingsMitIdUniqueList() {
    //If we already have a result send back the list and don't bother requesting
    if(this.buildingsMitIdUniqueList){
        return Promise.resolve(this.buildingsMitIdUniqueList);//return a resolved promise with the results
    }
    //If the request is still pending send back the existing promise to the caller.
    if(this.promiseBuildingsMitIdUniqueList){
        return this.promiseBuildingsMitIdUniqueList;
    }

    this.promiseBuildingsMitIdUniqueList = new Promise ((resolve, reject) => {

      axios.get('/api/v2/user/spaces/buildings/uniqueids')
        .then((response) => {
            this.promiseBuildingsMitIdUniqueList = null;
            return resolve(response.data.buildings);
        })
        .catch((error) => {
          console.log('ERROR:', error);
          this.promiseBuildingsMitIdUniqueList = null;
          return reject(error.response.data);
        });

    });

    return this.promiseBuildingsMitIdUniqueList
  }
  convertGeoJSONListtoSpaceModel(spaceGeojson){
      let spaceList = [];
      for(let x = 0; x < spaceGeojson.length; x++){
          spaceList.push(spaceGeojson[x].properties);
      }
      return spaceList;
  }
  saveSpaces(spacesList){
      return new Promise ((resolve, reject) => {
        axios.post('/api/v2/manager/spaces/list', spacesList)
          .then((response) => {
              return resolve(response.data);
          })
          .catch((error) => {
            console.log('ERROR:', error);
            return reject(error.response.data);
          });

      });
  }
  deleteSpaces(spacesList){
      let listIds = spacesList[0].id;

      for(let x = 1; x < spacesList.length; x++){
          listIds += ','+spacesList[x].id;
      }

      return new Promise ((resolve, reject) => {
        axios.delete('/api/v2/manager/spaces/list?ids='+listIds)
          .then((response) => {
              return resolve(response.data);
          })
          .catch((error) => {
            console.log('ERROR:', error);
            return reject(error.response.data);
          });

      });
  }
  getExistingBuildingObjectMitIds(buildingMitId){
      return new Promise ((resolve, reject) => {
        axios.get('/api/v2/manager/spaces/'+buildingMitId+'/mitids')
          .then((response) => {
              return resolve(response.data.existing);
          })
          .catch((error) => {
            console.log('ERROR:', error);
            return reject(error.response.data);
          });

      });
  }
  copyObjects(buildingMitId, fromVersion, toVersion) {
    return new Promise ((resolve, reject) => {
      axios.post('/api/v2/admin/spaces/buildings/'+buildingMitId+'/objects/copy', {
          fromVersion:fromVersion,
          toVersion:toVersion
      })
        .then((response) => {
            return resolve(response.data);
        })
        .catch((error) => {
          console.log('ERROR:', error);
          return reject(error);
        });

    });
  }

  deleteObjects(buildingMitId, fromVersion) {
    return new Promise ((resolve, reject) => {
      axios.delete('/api/v2/admin/spaces/buildings/'+buildingMitId+'/'+fromVersion+'/objects/delete')
        .then((response) => {
            return resolve(response.data);
        })
        .catch((error) => {
          console.log('ERROR:', error);
          return reject(error);
        });

    });
  }
  copySpaceNames(buildingMitId, fromVersion, toVersion) {
    return new Promise ((resolve, reject) => {
      axios.post('/api/v2/admin/spaces/buildings/'+buildingMitId+'/spaces/copy/data', {
          fromVersion:fromVersion,
          toVersion:toVersion
      })
        .then((response) => {
            return resolve(response.data);
        })
        .catch((error) => {
          console.log('ERROR:', error);
          return reject(error);
        });

    });
  }

  uploadSpaceImage(spaceId, image, imageIndex){
    return new Promise ((resolve, reject) => {
        let formData = new FormData();

        formData.append("spaceId", spaceId);
        formData.append("imageIndex", imageIndex);
        formData.append("image", image);

        axios.post('/api/v2/manager/spaces/images', formData, {headers: {'Content-Type': 'multipart/form-data'} })
            .then((response) => {
                return resolve(response.data);
            })
            .catch((error) => {
              console.log('ERROR:', error);
              return reject(error);
            });
    });
  }
  
  deleteSpaceImage(imageName){
    return new Promise ((resolve, reject) => {

        axios.delete('/api/v2/manager/spaces/images/'+imageName)
            .then((response) => {
                return resolve(response.data);
            })
            .catch((error) => {
              console.log('ERROR:', error);
              return reject(error);
            });
    });
  }

}

export default new MitSpacesService();
